import { render, staticRenderFns } from "./HistoryPrice.vue?vue&type=template&id=0b9f7c8d"
import script from "./HistoryPrice.vue?vue&type=script&lang=js"
export * from "./HistoryPrice.vue?vue&type=script&lang=js"
import style0 from "./HistoryPrice.vue?vue&type=style&index=0&id=0b9f7c8d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports